// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {

  });
})(jQuery); 
